import React from 'react';
import { useRecordingAsset } from '../../../queries/ats/recordings/hooks';
import { DetailsDataProviderProps } from './details-data-provider';
import { useDetailsParams } from '../utils';
import { DetailsContextProvider } from '../details-context';
import { DataProviderChild } from './data-provider-child';

export function RecordingDetailsDataProvider({
  id,
  orderByProviderId,
  orderByServiceType,
  children,
  skeleton,
  fallback,
}: Omit<DetailsDataProviderProps, 'type'>) {
  const params = useDetailsParams();

  if (params.subType === undefined) {
    throw new Error(
      'RecordingDetailsViewLoader must be used within a Route with a path that includes "/details/recording/:subType/:id"',
    );
  }

  const {
    data: asset,
    error,
    isLoading,
  } = useRecordingAsset({
    id,
    type: params.subType,
    orderByProviderId,
    orderByServiceType,
  });

  if (isLoading) {
    return skeleton;
  }

  if (error) {
    return fallback;
  }

  if (asset === undefined) {
    if (process.env.NODE_ENV !== 'production') {
      console.error(`No asset found for id: ${id}`);
    }

    return fallback;
  }

  return (
    <DetailsContextProvider asset={asset}>
      <DataProviderChild asset={asset}>{(args) => children(args)}</DataProviderChild>
    </DetailsContextProvider>
  );
}
